module.exports = __webpack_public_path__ + "img/calibration.954fcc4e.svg";